import React, { Component, useCallback, useEffect, useState } from "react";

import { request, withRequest } from "../../../utils/request";
import Pagination from "../../general/Pagination";
import Modal from "../../general/Modal";
import Create from "./Create";
import Edit from "./Edit";
import Loader from "../../general/Loader";
import { auth } from "../../../utils/auth";
import { Link } from "react-router-dom";
import { getLink } from "../../../utils/helpers";
import { debounce } from "lodash";
import ReactSelect from "react-select";
import CambiarVendedorCliente from "./CambiarVendedorCliente";

const Usuarios = () => {
    const [usuarios, setUsuarios] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [almacenes, setAlmacenes] = useState([]);
    const [cuentas, setCuentas] = useState([]);
    const [empleados, setEmpleados] = useState([]);
    const [usuario, setUsuario] = useState({});
    const [usuarioVendedor, setUsuarioVendedor] = useState({});
    const [links, setLinks] = useState(null);
    const [meta, setMeta] = useState(null);
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showCambiarVendedorCliente, setShowCambiarVendedorCliente] = useState(false);
    const [deleteCallback, setDeleteCallback] = useState(() => true);
    const [loading, setLoading] = useState(true);
    const [filtros, setFiltros] = useState({});

    const getUsers = async (url = null) => {
        url = url ? url : "usuarios";
        const usuarios = await request(url);

        setLoading(true);

        if (usuarios.data) {
            setUsuarios(auth.is("admin") ? usuarios.data?.filter(usuario => usuario.sucursalActual === auth.getUser().sucursalActual) : usuarios.data);
            setLinks(usuarios.links);
            setMeta(usuarios.meta);
        }

        setLoading(false);
    };
    const toggleCreateModal = () => {
        setUsuario({ bloquear_balance: true });
        setShowCreate(!showCreate);
    };
    const toggleEditModal = (usuario) => {
        setUsuario(usuario);
        setShowEdit(!showEdit);
    };
    const getSucursales = async (url = null) => {
		url = url ? url : "sucursales";
		const sucursales = await request(url);

		if (sucursales.data) {
            setLoading(false);
            setSucursales(sucursales.data);
		}
	};
    const getAlmacenes = async (url = null) => {
		url = url ? url : "almacenes";
		const almacenes = await request(url);

		if (almacenes.data) {
            setLoading(false);
            setAlmacenes([{ id: "todos", nombre: "Todos" }, ...almacenes.data]);
		}
	};
    const getCuentas = async (url = null) => {
		url = url ? url : "cuentas";
		const cuentas = await request(url);

		if (cuentas.data) {
            setLoading(false);
            setCuentas([{ id: "todas", nombre: "Todas" }, ...cuentas.data]);
		}
	};
    const getEmpleados = async (url = null) => {
		url = url ? url : "empleados";
		const empleados = await request(url);

		if (empleados.data) {
            setLoading(false);
            setEmpleados(empleados.data);
		}
	};

    const onFiltroChange = debounce(async (value, filtro) => {
        const filters = {...filtros, [filtro]: value};
        setFiltros(filters);

        let query = Object.keys(filters).map((fil) => {
            return `${fil}=${filters[fil]}`;
        });

        getUsers("usuarios?limit=15&" + query.join("&"));
    }, 500);

    useEffect(() => {
        getUsers();
        getSucursales();
        getAlmacenes();
        getCuentas();
        getEmpleados();
    }, []);

    return (
        <div>
            <div className='page-header'>
                <Link to={getLink('/configuracion/')}>&laquo; Volver a configuración</Link>
                <h1 className='page-title row'>
                    <span className='col'>Usuarios</span>
                    <button
                        className='au-btn au-btn-icon au-btn--green au-btn--small'
                        onClick={toggleCreateModal}>
                        <i className='zmdi zmdi-plus' />
                        Añadir Usuario
                    </button>
                </h1>
                <div className='page-controls'>
                    <div className='table-data__tool'>
                        <div className='table-data__tool-left row'>
                            <div className='col'>
                                <label htmlFor='search'>Buscar</label>
                                <input
                                    onChange={(e) =>
                                        onFiltroChange(
                                            e.target.value,
                                            "buscar"
                                        )
                                    }
                                    type='search'
                                    placeholder='Buscar...'
                                    className='form-control'
                                    name='buscar'
                                />
                            </div>


                            <div className='col-md-2'>
                                <label htmlFor='grupo'>Empleado</label>
                                <ReactSelect
                                    name='empleado'
                                    key='empleado'
                                    onChange={(e) =>
                                        onFiltroChange(
                                            e.value,
                                            "empleado_id"
                                        )
                                    }
                                    options={empleados.map((s) => {
                                        return {value: s.id, label: `${s.nombre}  ${s.apellido}`};
                                    })}
                                    />
                            </div>

                            <div className='col-md-2'>
                                <label htmlFor='grupo'>Estado</label>
                                <ReactSelect
                                    name='estado'
                                    key='estado'
                                    onChange={(e) =>
                                        onFiltroChange(
                                            e.value,
                                            "estado"
                                        )
                                    }
                                    options={[
                                        {value: '', label: 'Todos'},
                                        {value: 'inactivo', label: 'Inactivos'},
                                        {value: 'activo', label: 'Activos'},
                                    ]}
                                />
                            </div>
                            <div className='col-md-2'>
                                <label htmlFor='grupo'>Rol</label>
                                <ReactSelect
                                    name='rol'
                                    key='rol'
                                    onChange={(e) =>
                                        onFiltroChange(
                                            e.value,
                                            "rol"
                                        )
                                    }
                                    options={[
                                        {value: '', label: 'Todos'},
                                        {value: 'rrhh', label: 'rrhh'},
                                        {value: 'admin', label: 'admin'},
                                        {value: 'editor', label: 'editor'},
                                        {value: 'digitador', label: 'digitador'},
                                        {value: 'compras', label: 'compras'},
                                        {value: 'gasto', label: 'gasto'},
                                        {value: 'nomina', label: 'nomina'},
                                        {value: 'solicitudes', label: 'tareas'},
                                        {value: 'vendedor', label: 'vendedor'},
                                        {value: 'vendedor-factura', label: 'vendedor-factura'},
                                        {value: 'vendedor-admin', label: 'vendedor-admin'},
                                        {value: 'vendedor-factura-orden_compra', label: 'vendedor-factura-orden_compra'},
                                        {value: 'edu.caja', label: 'edu.caja'},
                                        {value: 'edu.recepcion', label: 'edu.recepcion'},
                                        {value: 'super-admin', label: 'super-admin'},
                                    ]}
                                    />
                            </div>
                            <div className='col-md-2'>
                                <label htmlFor='grupo'>Sucursal</label>
                                <ReactSelect
                                    name='rol'
                                    key='rol'
                                    onChange={(e) =>
                                        onFiltroChange(
                                            e.value,
                                            "sucursal_id"
                                        )
                                    }
                                    options={sucursales.map((s) => {
                                        return {value: s.id, label: s.nombre};
                                    })}
                                    />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-md-12'>
                    <div>
                        {loading ? (
                            <Loader />
                        ) : (
                            <div className='table-data'>
                                <table className='table table-data2'>
                                    <thead>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Empleado</th>
                                            <th>Usuario</th>
                                            <th className='text-center'>
                                                Activo
                                            </th>
                                            <th>Rol</th>
                                            <th>Sucursal</th>
                                            <th />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {usuarios
                                            ?.filter((usr) =>
                                                auth.is("super-admin")
                                                    ? true
                                                    : usr.rol !==
                                                        "super-admin"
                                            )
                                            .map((usr) => {
                                                return (
                                                    <tr
                                                        className='tr-shadow'
                                                        key={usr.id}>
                                                        <td>
                                                            {usr.nombre}{" "}
                                                            {usr.apellido}
                                                        </td>
                                                        <td>
                                                            {usr.empleado?.nombre}{" "}
                                                            {usr.empleado?.apellido}
                                                        </td>
                                                        <td>
                                                            {usr.usuario}
                                                        </td>
                                                        <td className='text-center'>
                                                            <span
                                                                className={`status ${
                                                                    usr.estado
                                                                        ? "active"
                                                                        : ""
                                                                }`}
                                                            />
                                                        </td>
                                                        <td>
                                                            <span className='role user'>
                                                                {usr.rol}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            {usr.sucursales.map(u => u.nombre).join(', ')}
                                                        </td>
                                                        <td>
                                                            <div className='table-data-feature'>
                                                                <button
                                                                    className='item'
                                                                    data-toggle='tooltip'
                                                                    data-placement='top'
                                                                    title=''
                                                                    data-original-title='Edit'
                                                                    onClick={() => {
                                                                        toggleEditModal(
                                                                            usr
                                                                        );
                                                                    }}>
                                                                    <i className='zmdi zmdi-edit' />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        {links && (
                            <Pagination
                                links={links}
                                meta={meta}
                                getData={getUsers}
                            />
                        )}
                    </div>
                </div>
            </div>
            <Modal size='md'
                show={showCreate}
                blank={true}
                toggle={toggleCreateModal}>
                <Create
                    toggle={toggleCreateModal}
                    usuario={usuario}
                    getUsers={getUsers}
                    filters={filtros}
                    sucursales={sucursales}
                    almacenes={almacenes}
                    cuentas={cuentas}
                />
            </Modal>
            <Modal size='md'
                show={showEdit}
                blank={true}
                toggle={() => toggleEditModal({})}>
                <Edit
                    toggle={() => toggleEditModal({})}
                    usuario={usuario}
                    getUsers={getUsers}
                    filters={filtros}
                    sucursales={sucursales}
                    almacenes={almacenes}
                    cuentas={cuentas}
                    onDeleteVendedor={async (usuarioVendedor, callback) => {
                        setShowCambiarVendedorCliente(true);
                        setUsuarioVendedor(usuarioVendedor);
                        setDeleteCallback(() => callback);
                    }}
                />
            </Modal>
            <Modal size='md'
                show={showCambiarVendedorCliente}
                blank={true}
                closeWithEsc={false}>
                    <CambiarVendedorCliente 
                        usuarioVendedor={usuarioVendedor}
                        callback={deleteCallback}
                        toggle={() => {
                            setShowCambiarVendedorCliente(!showCambiarVendedorCliente);
                        }}>
                    </CambiarVendedorCliente>
            </Modal>
        </div>
    );
};

export default withRequest(Usuarios);
